import * as api from 'dashboard/resources/license-renewal.api';
import actionTypes from './action-types';

export const fetchLicenseRenewalRequest = () => ({
  type: actionTypes.FETCH_LICENSE_RENEWAL_REQUEST,
  name: 'licenseRenewalLoadingStatus',
});

export const fetchLicenseRenewalSuccess = (data) => ({
  type: actionTypes.FETCH_LICENSE_RENEWAL_SUCCESS,
  name: 'licenseRenewalLoadingStatus',
  data,
});

export const fetchLicenseRenewalFailure = () => ({
  type: actionTypes.FETCH_LICENSE_RENEWAL_FAILURE,
  name: 'licenseRenewalLoadingStatus',
});

export const fetchLicenseRenewal =
  (id = null) =>
  async (dispatch, getState) => {
    try {
      const { session, config } = getState();
      const { licenseRenewalMaxDaysNo } = config;
      const retailerId = id || session.retailer.retailerId;

      dispatch(fetchLicenseRenewalRequest());
      const data = await api.fetchLicenseRenewal(retailerId, licenseRenewalMaxDaysNo);
      dispatch(fetchLicenseRenewalSuccess(data));
    } catch (error) {
      console.error('LICENSE_RENEWAL', error);
      dispatch(fetchLicenseRenewalFailure());
    }
  };



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/license-renewal/license-renewal.actions.js